export default {
  getHead: () => {
    return [{ name: "사업장명" }, { name: "요청자 구분" }, { name: "요청일" }, { name: "재해형태" }, { name: "조치 현황" }, { name: "조치 완료일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).targetCompany; // 사업장명
        case 1:
          return func.getContent(value).type; // 요청자 구분
        case 2:
          return func.getContent(value).inputC_8; // 요청일
        case 3:
          return func.getContent(value).inputC_6; // 재해형태
        case 4:
          return func.getContent(value).inputE_5; // 조치현황
        case 5:
          return func.getContent(value).inputE_6; // 조치완료일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.disasterType) returnData.push("content$body.inputC_6*[:default_disaster]");

    switch (nav.value.searchType) {
      case "사업장명":
        returnData.push("content$body.targetCompany*%[:default_skw]%");
        break;
      case "소속명":
        returnData.push("content$body.inputC_2*%[:default_skw]%");
        break;
      case "부서명":
        returnData.push("content$body.inputC_3*%[:default_skw]%");
        break;
      case "요청자 구분":
        returnData.push("content$body.type*%[:default_skw]%");
        break;
      case "대상":
        returnData.push("content$body.inputC_5*%[:default_skw]%");
        break;
      case "요청일":
        returnData.push("content$body.inputC_8*%[:default_skw]%");
        break;
      case "조치현황":
        returnData.push("content$body.inputE_5*%[:default_skw]%");
        break;
      case "조치완료일":
        returnData.push("content$body.inputE_6*%[:default_skw]%");
        break;
    }

    return returnData;
  },
};
